import React from 'react'
import { IconProps } from './interfaces/IconProps.interface'

const ContactsBook = (props: IconProps) => {
    const { color = "#000", ...rest } = props

    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
            <g clipPath="url(#clip0_10103_6461)">
                <path d="M13.3333 14.6668H4C3.46957 14.6668 2.96086 14.4561 2.58579 14.081C2.21071 13.706 2 13.1973 2 12.6668V3.3335C2 2.80306 2.21071 2.29436 2.58579 1.91928C2.96086 1.54421 3.46957 1.3335 4 1.3335H13.3333C13.5101 1.3335 13.6797 1.40373 13.8047 1.52876C13.9298 1.65378 14 1.82335 14 2.00016V14.0002C14 14.177 13.9298 14.3465 13.8047 14.4716C13.6797 14.5966 13.5101 14.6668 13.3333 14.6668ZM12.6667 13.3335V12.0002H4C3.82319 12.0002 3.65362 12.0704 3.5286 12.1954C3.40357 12.3204 3.33333 12.49 3.33333 12.6668C3.33333 12.8436 3.40357 13.0132 3.5286 13.1382C3.65362 13.2633 3.82319 13.3335 4 13.3335H12.6667ZM8 6.66683C8.35362 6.66683 8.69276 6.52635 8.94281 6.2763C9.19286 6.02626 9.33333 5.68712 9.33333 5.3335C9.33333 4.97987 9.19286 4.64074 8.94281 4.39069C8.69276 4.14064 8.35362 4.00016 8 4.00016C7.64638 4.00016 7.30724 4.14064 7.05719 4.39069C6.80714 4.64074 6.66667 4.97987 6.66667 5.3335C6.66667 5.68712 6.80714 6.02626 7.05719 6.2763C7.30724 6.52635 7.64638 6.66683 8 6.66683ZM6 9.3335H10C10 8.80306 9.78929 8.29435 9.41421 7.91928C9.03914 7.54421 8.53043 7.3335 8 7.3335C7.46957 7.3335 6.96086 7.54421 6.58579 7.91928C6.21071 8.29435 6 8.80306 6 9.3335Z" fill={color} />
            </g>
            <defs>
                <clipPath id="clip0_10103_6461">
                    <rect width="16" height="16" fill="white" />
                </clipPath>
            </defs>
        </svg>

    )
}

export default ContactsBook